import { isHandledErrorResponse, isResponseWithMessages,isUnauthorizedResponse } from 'core/api/apiHelpers';
import * as I from 'core/api/coreApiClient';
import {
commandDeleteFailed, commandSaveFailed, commandUpdateFailed,
  startCommand, } from 'core/redux/actions/command/commandActions';
import {
clearNotification, enqueueInfoNotification,
  enqueueWarningNotification, } from 'core/redux/actions/notification/notificationActions';
import { copyToClipboardAction } from 'core/redux/actions/ui/uiActions';
import { loggingInUser,loginFailed, logoutFailed } from 'core/redux/actions/user/userActions';
import type {
AnyAction,
  Middleware, } from 'redux';

const notificationGeneratorMiddleware: Middleware = (store) => (next) => (action: AnyAction) => {
  if (commandUpdateFailed.match(action) || commandSaveFailed.match(action) || commandDeleteFailed.match(action)) {
    if (
      action.payload.errorResponse
      && !isHandledErrorResponse(action.payload.errorResponse.status)
      && !isResponseWithMessages(action.payload.errorResponse?.data)
    ) {
      if (isUnauthorizedResponse(action.payload.errorResponse.status)) {
        store.dispatch(enqueueWarningNotification('Session timed out. Please login again.'));
      } else if (action.payload.errorMsg) {
        store.dispatch(enqueueWarningNotification(action.payload.errorMsg));
      }
    } else if (action.payload.error && action.payload.errorMsg) {
      store.dispatch(enqueueWarningNotification(action.payload.errorMsg));
    }
  } else if (loginFailed.match(action) || logoutFailed.match(action)) {
    store.dispatch(enqueueWarningNotification(action.payload.errorMsg));
  }

  if (loggingInUser.match(action)) {
    store.dispatch(clearNotification());
  }

  if (startCommand.match(action)) {
    if (action.payload.command.commandType === I.CommandTypeConstants.RESTResource
      && action.payload.command.httpVerb !== I.HttpVerbConstants.GET
      && action.payload.command.id !== 'rowSelection'
      && !action.payload.command.url?.match('inTableEdit=')
      && !action.payload.command.url?.match('/paging')
    ) {
      store.dispatch(clearNotification());
    }
  }

  if (copyToClipboardAction.match(action)) {
    if (action.payload.message) {
      store.dispatch(enqueueInfoNotification(action.payload.message));
    }
  }

  next(action);
};

export default notificationGeneratorMiddleware;
